import React from "react"

import { Box, Container, Grid, List, ListItem, Typography } from "@mui/material"
import PaperBox from "components/PaperBox"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import { allRoutes } from "generated/routes"
import ImportResult from "./components/ImportResult"
import { SimpleUploadFile } from "./components/SimpleUploadFile"
import { useTranslation } from "react-i18next"

const ImportLegacyExams = ({ match }) => {
  const [importResult, setImportResult] = React.useState()
  const { t } = useTranslation()

  return (
    <div>
      <PageTabs
        routeBack
        tabs={[
          {
            path: allRoutes.SystemadminCustomersEditUsers(match.params.id),
            title: t("global.back", "Back")
          }
        ]}
      />
      <Container>
        <Box marginY={3}>
          <Grid item container direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h2">Importera utbildningsresultat från förra utbildningstjänsten</Typography>
          </Grid>
        </Box>
        <PaperBox>
          <Box mb={2}>
            <Typography>
              {t(
                "settings.customer.import_data_by_uploading_a_file",
                "Import data by uploading a file in CSV format. Separators should be semicolons (;) and fields with list values ​​should be separated by commas (,)"
              )}
            </Typography>
            <Box mb={2}></Box>
            <Typography>
              {t(
                "settings.customer.file_must_not_use_column_headings",
                "Filen får inte använda rubriker på kolumnerna utan endast innehålla data"
              )}
            </Typography>
            <Box mb={2}></Box>
            <Typography>
              {t(
                "settings.customer.the_format_of_each_row_must_include",
                "The format of each row must include the following columns"
              )}
              :
            </Typography>
            <List>
              <ListItem>{t("settings.customer.username_required_the_user_who_will_recive", "")}</ListItem>
              <ListItem>
                {t(
                  "settings.customer.education_name_required_the_name_of_the",
                  "Education name - Required, the name of the education in this system that the results should be linked to"
                )}
              </ListItem>
              <ListItem>
                {t(
                  "settings.customer.points_required_number_of_points",
                  "Points - Required, Number of points from the previous system"
                )}
              </ListItem>
              <ListItem>
                {t(
                  "settings.customer.url_to_pdf_required",
                  "URL To PDF - Required, Full URL+path to the document containing details of the result. (Probably ex. https://cloudplanningpdfarchive.blob.core.windows.net/testpdfs/Utbildning%20och%20Namn.pdf)"
                )}
              </ListItem>
              <ListItem>
                {t(
                  "settings.customer.passed_required_yes_no",
                  "Passed - Required, Yes/No whether the result is a passed result or not"
                )}
              </ListItem>
              <ListItem>
                {t(
                  "settings.customer.date_required_date_and_time_in_local",
                  `Date - Required, Date and time in local Swedish time when the test was created. (For example "2019-04-06 15:50:00")`
                )}
              </ListItem>
            </List>
            <Box mb={2}></Box>
            <Typography>
              {t(
                "settings.customer.if_any_row_has_validation_errors",
                "If any row has validation errors, no rows will be imported. In that case, correct the missing row and upload the file again"
              )}
            </Typography>
            <Box mb={2}></Box>
          </Box>
          <SimpleUploadFile setImportResult={setImportResult} />
          {importResult?.status === 2 && <ImportResult result={importResult} />}
        </PaperBox>
      </Container>
    </div>
  )
}
export default ImportLegacyExams
